import { render, staticRenderFns } from "./WorkModal.vue?vue&type=template&id=23d96b78&scoped=true"
import script from "./WorkModal.vue?vue&type=script&lang=js"
export * from "./WorkModal.vue?vue&type=script&lang=js"
import style0 from "./WorkModal.vue?vue&type=style&index=0&id=23d96b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d96b78",
  null
  
)

export default component.exports